import React, { FC } from 'react';
import logo from './logo.svg';
import './App.css';
import { Route, Routes } from "react-router-dom";
import { SubscriptionPuchasePage } from './pages/SubscriptionPuchasePage';
import { MainLayout } from './layout/MainLayout';
import { AccountLayout } from './layout/AccountLayout';
import { EmptyLayout } from './layout/EmptyLayout';
import { ThanksPageLayout } from './layout/ThanksPageLayout';

import { ImageGenerationPage } from './pages/ImageGenerationPage';
import { GenerationDetailPage } from './pages/GenerationDetailPage';
import { ProfilePage } from './pages/account/ProfilePage';
import { SubscriptionPage } from './pages/account/SubscriptionPage';
import { InspirationPage } from './pages/InspirationPage';
import { GenerationHistoryPage } from './pages/account/GenerationHistoryPage';
import { PlanPage } from './pages/PlanPage';
import { TopPage } from './pages/TopPage';
import { SignupCompletePage } from './pages/thanks/SignupCompletePage';
import { CompanyPage } from './pages/static/CompanyPage';
import { CommercialTransactionsPage } from './pages/static/CommercialTransactionsPage';
import { PrivacyPolicyPage } from './pages/static/PrivacyPolicy';
import { TermsOfServicePage } from './pages/static/TermsOfServicePage';
import { AboutModelPage } from './pages/static/AboutModel';
import { LiteUpgradedPage } from './pages/thanks/LiteUpgradedPage';
import { StandardUpgradedPage } from './pages/thanks/StandardUpgradedPage';
import { CreditAddedPage } from './pages/thanks/CreditAddedPage';
import { CardRegisteredPage } from './pages/thanks/CardRegisteredPage';
import { AccountCancellation } from './pages/thanks/AccountCancellation';
import { AccountClosedPage } from './pages/thanks/AccountClosed';
import { LoginPage } from './pages/Login';
import { SignupPage } from './pages/Signup';
import { ContactPage } from './pages/static/Contact';
import { LiteFreePlanPage } from './pages/thanks/LiteFreePlanPage';
import { StandardFreePlanPage } from './pages/thanks/StandardFreePlanPage';
import { ProxyLoginPage } from './pages/ProxyLoginPage';

export const Router: FC = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<TopPage />} />
        <Route path="/image-generation" element={<ImageGenerationPage />} />
        <Route path="/inspiration" element={<InspirationPage />} />
        <Route path="/subscription-purchase" element={<SubscriptionPuchasePage />} />
        <Route path="/generation-detail" element={<GenerationDetailPage />} />
        <Route path="/plan" element={<PlanPage />} />
        <Route path="/company" element={<CompanyPage />} />
        <Route path="/commercial-transactions" element={<CommercialTransactionsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/about-model" element={<AboutModelPage />} />
        <Route path="/account-cancellation" element={<AccountCancellation />} />
        <Route path="/contact" element={<ContactPage />} />
      </Route>
      <Route element={<EmptyLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/proxy-login" element={<ProxyLoginPage />} />
      </Route>
      <Route element={<AccountLayout />}>
        <Route path="/account" element={<ProfilePage />} />
        <Route path="/generation-history" element={<GenerationHistoryPage />} />
        <Route path="/subscription" element={<SubscriptionPage />} />
      </Route>
      <Route element={<ThanksPageLayout />}>
        <Route path="/thxarigatoo_accountregistration" element={<SignupCompletePage />} />
        <Route path="/thxarigatoo_upgrade_lite" element={<LiteUpgradedPage />} />
        <Route path="/thxarigatoo_upgrade_standard" element={<StandardUpgradedPage />} />
        <Route path="/thxarigatoo_addcredit" element={<CreditAddedPage />} />
        <Route path="/thxarigatoo_creca" element={<CardRegisteredPage />} />
        <Route path="/thxarigatoo_cancelation" element={<AccountClosedPage />} />
        <Route path="/thxarigatoo_freetrial" element={<LiteFreePlanPage />} />
        <Route path="/thxarigatoo_freetrial_std" element={<StandardFreePlanPage />} />
      </Route>
    </Routes>
    )
}